import type {RefObject} from 'react';
import type {SocialPost} from '@Components/social-media/post.vo';

export interface WizardScheduleControlsProps {
  socialPost: SocialPost | undefined;
  anchorRef: RefObject<HTMLDivElement | null>;
  isDisabled: boolean;
  onOpenDateTimePicker: VoidFunction;
}

export const SCHEDULE_CONTROLS_ONBOARDING_ANCHOR_ID = 'add-details-onboarding-step-three';
